import { Component } from 'react';
import { LocalizedEnumify } from '@mews/framework';
import { alpha } from '@optimus-web/core';
import { getFillColor, RectangleElement, TooltipedRectangleContainer } from './style';

interface Props {
    value?: number;
    resourceCategoryType?: {};
    unit?: string;
    fillOpacity: number;
}

export default class ResourceCategoryTypeBar extends Component<Props> {
    getTooltip = () => {
        const { value, unit, resourceCategoryType } = this.props;
        return (
            <span>
                <LocalizedEnumify enumValue={resourceCategoryType} />
                <br />
                {value}
                {unit}
            </span>
        );
    };

    render() {
        const { value, fillOpacity } = this.props;
        const props = {
            ...this.props,
            fill: alpha(getFillColor(value), fillOpacity),
        };
        return (
            <TooltipedRectangleContainer tooltip={this.getTooltip()}>
                <RectangleElement {...props} />
            </TooltipedRectangleContainer>
        );
    }
}
